// extracted by mini-css-extract-plugin
module.exports = {"reassurance":"_1VfEv7pvPBg0_IrJtx8-_D","reasCol":"_1ZOmFKP3jTPI1HxYkSGVC_","text":"_1q0IUJJry5s6rYL24X3ZCO"};